import type { FaireProductEntity } from "../../entity_types/product";

export const p_85uejqhwgc: FaireProductEntity = {
  token: "p_85uejqhwgc",
  type: "product",
  name: "Mokonuts: The Cookbook",
  brandToken: "b_daarv8jc3a",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/42c7d2906d829af432eb384ef3351a704dc464d71393b418585c55b3e5f34629.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a9c28cd5d05fe1fd9e7b99eb1a504c090b93687641b1143be241fe7396f07403.jpeg",
    "https://cdn.faire.com/fastly/a518761b573e99b42c575be3ae34d3777c689ecbf42293f5c4f325fc8ff8a4a7.jpeg",
    "https://cdn.faire.com/fastly/0fb2e03d01f242dc769b6c362d452d0fa027bda38e68a7295d774da77b63bad9.jpeg",
    "https://cdn.faire.com/fastly/02f13701c7424f8fd06634a5bca946b3799bf722d9205c43d16a7cf151b693f4.jpeg",
    "https://cdn.faire.com/fastly/c649f428b3b05b4c556fd6e167d06631e5cb1181fec876e51c33216af8a09bb4.jpeg",
    "https://cdn.faire.com/fastly/9157fb43fca5fe95b79afbf3d653bfac0a2b779499f0b7169f1dd47201d45604.jpeg",
    "https://cdn.faire.com/fastly/ae1cc501af84273d3e04c0ae32104c6bf417356076398e388a1505e643fe2572.jpeg",
    "https://cdn.faire.com/fastly/2c41368922ff99c85c7f3964966586e8267d6fbcd02b4cbcb7236807537c6e76.jpeg",
  ],
  priceDollars: 24.98,
  description:
    "Recreate the eclectic dishes and intimate atmosphere of one of Paris’s most beloved restaurants\n\nImagine stepping into a tiny, bustling café in the heart of Paris, where the scent of a just-baked pear tart mingles with the rich aroma of slow-cooked lamb. You have entered Mokonuts, a restaurant like no other.\n\nMoko Hirayama and Omar Koreitem, the couple behind Mokonuts, are not just chefs – they are culinary storytellers with a rich, multicultural background. Their food blends Middle Eastern warmth, Japanese precision, French and Italian flavors, and American comfort, creating dishes that are as effortlessly sophisticated as they are approachable.\n\nMokonuts invites home cooks to recreate the restaurant’s welcoming atmosphere in their own kitchens. Divided into five sections – Morning, Appetizers, Mains, Larder, and Sweet – the book reveals how to easily recreate 100 delicious dishes that put this buzzy restaurant on the map.",
  tags: [],
  msrpDollars: 49.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:37.262Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
